import styled from '@emotion/styled'
import { theme, MediaQueries } from '@hhgtech/hhg-components'

export const StyledSources = styled.div`
  display: block;
  border: 1px solid ${theme.mbColors.lightGray};
  margin-bottom: 0.5rem;
  border-radius: 16px;

  ${MediaQueries.mbUp} {
    margin-bottom: 1rem;
  }

  --font-weight-lg: ${theme.sizes.fwBold};
  --font-weight-md: ${theme.sizes.fwSemiBold};
  --font-weight-sm: ${theme.sizes.fwRegular};
  &[data-size='lg'] {
    font-size: 18px;
    font-weight: var(--font-weight-lg);
    line-height: 26px;
  }
  &[data-size='md'] {
    font-size: 16px;
    font-weight: var(--font-weight-md);
    line-height: 24px;
  }
  &[data-size='sm'] {
    font-size: 14px;
    font-weight: var(--font-weight-sm);
    line-height: 22px;
  }
`
export const StyledHeading = styled.div`
  padding: 18px;
  cursor: pointer;

  .icon-text {
    color: ${theme.colors.gray600};
    font-weight: bold;
    line-height: 1.5;
    ${MediaQueries.mbDown} {
      font-size: 0.7rem;
    }
    ${MediaQueries.mbUp} {
      font-size: 1rem;
    }
    .source-icon {
      width: 1.5rem;
    }
  }
`

export const StyledExpandableContainer = styled.div`
  overflow: hidden;
  height: 0;
  transition: height 0.4s ease;

  .source-wrapper {
    padding: 1rem;
    border-radius: 6px;
    ${MediaQueries.mbUp} {
      padding: 0 1rem 1rem 1rem;
    }

    * {
      max-width: 100%;
    }

    a {
      display: inline-block;
      color: ${theme.colors.primaryBase};
      font-weight: normal;
      text-decoration: none;
      word-break: break-word;
    }

    > p {
      word-break: break-all;
    }
    > p:not(:last-child) {
      margin-bottom: 1rem;
    }
  }
`
export const StyledSource = styled.p`
  margin-bottom: 0.4rem;
`
